import { __assign, __rest } from "tslib";
import React from 'react';
import { InputAdornment } from '@tencent/tea-component/lib/inputadornment';
import classNames from 'classnames';
export function BuyInputAdornment(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement(InputAdornment, __assign({}, rest, { className: classNames('buy-item-input__after', className) }), children));
}
//# sourceMappingURL=BuyInputAdornment.js.map